module.exports = __webpack_public_path__ + "img/shop-1.61922aa0.png";